import { ClientStoreContextWrapper } from "@hospital/contexts";
import { ClientStore } from "@hospital/views/clients/ClientStore";

import React, { useContext, useEffect, useMemo, useState } from "react";

/**
 * Create a ClientStore while optionally setting it in the ClientStore Context Wrapper.  You might want to set it in context so child components can access the same instance of the ClientStore
 * @param options 
 * @returns 
 */
export const useCreateClientStore = (options?: { shouldSetContext?: boolean,shouldUpdateContext?: boolean }) => {
    const [shouldSetContext, setShouldSetContext] = useState<boolean>(Boolean(options?.shouldSetContext));
    const [shouldUpdateContext, setShouldUpdateContext] = useState<boolean>(Boolean(options?.shouldUpdateContext));

    useEffect(() => {
        if (options)
            setShouldSetContext(Boolean(options.shouldSetContext));
            setShouldUpdateContext(Boolean(options?.shouldUpdateContext));
    }, [options])

    const [clientStore] = useMemo(() => {
        const store = new ClientStore();
        if (shouldSetContext || shouldUpdateContext)
            ClientStoreContextWrapper.set(store);
        return [store];
    }, [shouldSetContext,shouldUpdateContext]);
    return clientStore;
}

//Will return a new client store if ClientStoreContextWrapper has not been set
export const useClientStore = () => {
    const [context] = useState<React.Context<ClientStore>>(ClientStoreContextWrapper.get() ?? React.createContext(new ClientStore()));
    return useContext(context);
}
